/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMiAyLjc3ODc3VjJIMTJWMi43Nzg3N0gyWk01LjExNzY5IDUuMDgwODNWNC4zMDIwNkgxMlY1LjA4MDgzSDUuMTE3NjlaTTIgNy4zODc3NlY2LjYwODk5SDEyVjcuMzg3NzZIMlpNNS4xMTc2OSA5LjY4OTgyVjguOTExMDVIMTJWOS42ODk4Mkg1LjExNzY5Wk0yIDEyVjExLjIyMTJIMTJWMTJIMloiIGZpbGw9ImJsYWNrIi8+PC9zdmc+";